// 경기 종목(혼복·남복·여복·잡복) 비율 막대 + 범례.

import type { TypeBuckets } from "../../stats";

interface TypeBarProps {
  types: TypeBuckets;
  total: number;
}

const TYPE_ITEMS: Array<{ key: keyof TypeBuckets; label: string; color: string }> = [
  { key: "mixed", label: "혼복", color: "#6366f1" },
  { key: "men", label: "남복", color: "#0ea5e9" },
  { key: "women", label: "여복", color: "#ec4899" },
  { key: "exceptional", label: "잡복", color: "#f59e0b" },
];

export function TypeBar({ types, total }: TypeBarProps) {
  const items = TYPE_ITEMS
    .map(t => ({ ...t, count: types[t.key] }))
    .filter(t => t.count > 0);
  return (
    <div>
      <div class="type-bar">
        {items.map(it => {
          const pct = Math.round((it.count / total) * 100);
          return (
            <span
              class="type-bar__seg"
              style={`width:${pct}%;background:${it.color}`}
              title={`${it.label} ${it.count}경기 (${pct}%)`}
            />
          );
        })}
      </div>
      <div class="type-bar__legend">
        {items.map(it => (
          <span class="type-bar__legend-item">
            <span class="type-bar__dot" style={`background:${it.color}`} />
            {`${it.label} ${it.count}`}
          </span>
        ))}
      </div>
    </div>
  );
}
